function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
import useAxios from "../../../../../Hooks/use-axios";
import { toast } from "react-toastify";
var useData = function useData(paymentId) {
  var _redux$isAuthenticate, _redux$auth;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    payment = _useState2[0],
    setPayment = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showError = _useState4[0],
    setShowError = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    deals = _useState6[0],
    setDeals = _useState6[1];
  var isAuthenticated = (_redux$isAuthenticate = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated) !== null && _redux$isAuthenticate !== void 0 ? _redux$isAuthenticate : redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated;
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingOrder = _useAxios.isLoading,
    error = _useAxios.error,
    fetchOrderDetails = _useAxios.sendRequest;
  var _useAxios2 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingDeals = _useAxios2.isLoading,
    fetchDeals = _useAxios2.sendRequest;
  var fetchOrder = function fetchOrder() {
    console.log("forbidden");
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "get",
      url: "winnre/user/payment/get/".concat(paymentId)
    }).then(function (data) {
      var _window;
      if (data.status === "FAILED") {
        setShowError(true);
        //    toast.error(data.message);
      } else {
        setShowError(false);
      }
      console.log("payment details", data);
      (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("PaymentStatus", {
        Status: (data === null || data === void 0 ? void 0 : data.paymentStatus) === "SUCCESS" ? "SUCCESS" : "FAILED",
        paymentId: data === null || data === void 0 ? void 0 : data.id,
        DealID: data === null || data === void 0 ? void 0 : data.dealId,
        Amount: data === null || data === void 0 ? void 0 : data.amount,
        TransactionID: data === null || data === void 0 ? void 0 : data.paymentReferenceNumber,
        PaymentID: data === null || data === void 0 ? void 0 : data.id
      });
      setPayment(data);
    })["catch"](function (error) {
      console.log("error order", error);
      setShowError(true);
    });
  };
  useEffect(function () {
    getOffers();
  }, []);
  var getOffers = function getOffers() {
    fetchDeals({
      isEncryptedResponse: isAuthenticated ? true : false,
      url: "/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=10&rewardsPage=true",
      method: "get",
      isFormData: true
    }, function (res) {
      console.log("ordersPage Deals", res === null || res === void 0 ? void 0 : res.content);
      setDeals(res === null || res === void 0 ? void 0 : res.content);
    });
  };
  useEffect(function () {
    fetchOrder();
  }, [paymentId, isAuthenticated]);
  useEffect(function () {
    getOffers();
  }, []);
  return {
    payment: payment,
    loadingOrder: loadingOrder,
    showError: showError,
    isAuthenticated: isAuthenticated,
    deals: deals
  };
};
export default useData;